<template>
  <div>
    <div class="titileDefinition">账号设置</div>
    <div class="section-right-content-box">
      <div class="checked-content-box">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">系统提示</span>
        </div>
        <top-title
          style="margin-left: 50px"
          desc="手机号设置后，可免费接收以下信息！（完全免费）"
          classType="1"
        ></top-title>
        <div class="checked-box">
          <div class="item">
            <el-checkbox v-model="checkedLin" @change="checkSms" class="check">
              <span style="color:#666666"
                >每天9点前发送前一天自动催付效果、短信发送量和当前短信条数（为避免打扰，每天发送数量超过100条才发送）</span
              >
            </el-checkbox>
            <el-checkbox v-model="checked" @change="checkSms" class="check">
              <span style="color:#666666">软件短信不足</span>
              <el-input
                v-model="userInfo.balanceRemindNum"
                class="input"
                size="small"
                oninput="value=value.replace(/[^\d]/g,'')"
                style="min-width: 100px"
              ></el-input>
              <span style="color:#666666">条，发送提醒</span>
            </el-checkbox>
            <el-checkbox v-model="checkedOne" @change="checkExp" class="check">
              <span style="color:#666666">软件到期不足</span>
              <el-input
                v-model="userInfo.softwareExpireDay"
                class="input"
                oninput="value=value.replace(/[^\d]/g,'')"
                size="small"
              ></el-input>
              <span style="color:#666666">天发送提醒。</span>
            </el-checkbox>
          </div>
        </div>
      </div>
      <div class="input-content-box">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">联系人信息</span>
        </div>
        <top-title
          style="margin-left: 50px"
          desc="为保障系统安全，在进行敏感操作时，需要通过所留手机号验证操作人身份"
          classType="1"
        ></top-title>
        <div class="input-box">
          <div class="item">
            &nbsp;&nbsp;
            <span class="item-name">姓名</span>
            <el-input
              v-model="userInfo.sellerNick"
              :disabled="editDisabled"
              class="input"
              placeholder="请输入姓名"
              :maxlength="50"
              size="small"
            ></el-input>
            <span class="fenHao">*</span>
          </div>
          <div class="item">
            &nbsp;&nbsp;
            <span class="item-name">QQ</span>
            <el-input
              class="input"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="用于软件指导"
              :disabled="editDisabled"
              v-model="qqPhone.qq"
              size="small"
            ></el-input>
            <span class="fenHao">*</span>
          </div>
          <div class="item">
            <span style="margin-right: 11px">手机号</span>
            <!--  @change="checkPhone"
                  id="phone"
                  @input="verificationCode" -->

            <el-input
              v-model="qqPhone.mobile"
              @change="checkPhone"
              :disabled="editDisabled"
              id="phone"
              @input="verificationCode"
              class="input"
              oninput="value=value.replace(/[^\d]/g,'')"
              :maxlength="11"
              placeholder="仅用于绑定公众号实时监控店铺数据"
              size="small"
            ></el-input>
            <span class="fenHao">*</span>
          </div>
          <div class="item" style="margin-bottom: 40px">
            <span>验证码</span>&nbsp;&nbsp;
            <el-input
              v-model="message.vcode"
              type="number"
              :disabled="editDisabled"
              class="code-input"
              size="small"
            ></el-input>
            <el-button plain size="small" v-zoom='{from:pageName,name:buttonContent}' @click="getMesaage" :disabled="dis || editDisabled">{{
              buttonContent
            }}</el-button>
          </div>
          <div style="text-align: center;border-top: 1px solid #ddd;">
            <el-button
              @click="saveSetting"
              class="b1"
              size="small"
              v-zoom='{from:pageName,name:"确定"}'
              style="margin-top: 10px; width: 98px"
              >确定</el-button
            >&nbsp;
            <el-button
              @click="editDisabled = false"
              class="b2"
              size="small"
              v-zoom='{from:pageName,name:"修改"}'
              style="margin-top: 10px; width: 98px"
              >修改</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  querySellerSetting,
  updateSellerSetting,
  checkCodeSet,
} from "@/api/backstage/a_setting";
import topTitle from "@/components/top-title.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "accountset",
  components: {
    topTitle,
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  data() {
    return {
      pageName:"后台管理-账户设置",
      userInfo: {
        //获取账号设置的信息
        balanceRemindIsopen: "",
        balanceRemindNum: "",
        sellerNick: "",
        //  mobile:"",
        //  qq:"",
        sendMessageIsopen: "",
        softwareExpireDay: "",
        softwareExpireIsopen: "",
        vcode: "",
      },
      userInfoOne: {
        contactName: "",
        vcode: "",
        mobile: "",
        qq: "",
      },
      qqPhone: {}, //qq和手机
      message: {
        //验证码
        vcode: "",
      },
      checkedLin: false, //
      checked: false, //选择框
      checkedOne: false,
      checkedTwo: false,
      checkedThree: false,
      buttonContent: "获取验证码",
      totalTime: 60,
      timer: "",
      dis: false,
      bindingPhoneNum: "",
      editDisabled: true,
    };
  },
  mounted: function () {
    this.querySellerSetting();
  },
  methods: {
    //获取账户信息
    querySellerSetting() {
      querySellerSetting({})
        .then((res) => {
          this.userInfo = res.data.tbPhoneBindingVO;
          this.bindingPhoneNum = res.data.tbPhoneBindingVO.bindingPhone;
          this.qqPhone = res.data.sellerVO;
          if (this.userInfo.sendMessageIsopen === 1) {
            this.checkedLin = false;
          } else {
            this.checkedLin = true;
          }

          if (this.userInfo.balanceRemindIsopen === 1) {
            this.checked = false;
          } else {
            this.checked = true;
          }

          if (this.userInfo.softwareExpireIsopen === 1) {
            this.checkedOne = false;
          } else {
            this.checkedOne = true;
          }
        })
        .catch((e) => {});
    },
    checkSms(value) {
      if (value == false) {
        this.userInfo.balanceRemindNum = "";
      }
    },
    checkExp(value) {
      if (value == false) {
        this.userInfo.softwareExpireDay = "";
      }
    },
    //发送验证码
    getMesaage() {
      this.dis = !this.dis;
      // let
      this.userInfo.bindingPhone = this.qqPhone.mobile;
      if (this.userInfo.bindingPhone.indexOf("*") > -1) {
        this.userInfo.bindingPhone = this.bindingPhoneNum;
      }
      checkCodeSet({
        bindingPhone: this.userInfo.bindingPhone,
      })
        .then((res) => {})
        .catch((e) => {});
      let _that = this;
      _that.dis = true;
      let clock = window.setInterval(() => {
        _that.totalTime--;
        _that.buttonContent = _that.totalTime + "s后重新发送";
        if (_that.totalTime === 0) {
          window.clearInterval(clock);
          _that.totalTime = 60;
          _that.buttonContent = "获取验证码";
          _that.dis = false;
        }
      }, 1000);
      this.timer = clock;
    },
    //保存设置
    saveSetting() {
      if (this.checked && this.userInfo.balanceRemindNum == "") {
        this.$message("输入软件条数");
        return;
      }
      if (this.checkedOne && this.userInfo.softwareExpireDay == "") {
        this.$message("输入到期天数");
        return;
      }
      this.userInfo.vcode = this.message.vcode;
      if (this.userInfo.sellerNick && this.userInfo.sellerNick.length > 50) {
        this.$message.error("姓名为不超过50个字的汉字或英文");
        return;
      }
      if (this.userInfo.vcode == "") {
        this.$message.error("验证码不能为空");
        return;
      }
      window.clearInterval(this.timer);
      this.totalTime = 60;
      this.buttonContent = "获取验证码";
      this.dis = false;
      this.userInfo.balanceRemindIsopen = this.checked == true ? 0 : 1;
      this.userInfo.softwareExpireIsopen = this.checkedOne == true ? 0 : 1;
      this.userInfo.sendMessageIsopen = this.checkedLin == true ? 0 : 1;
      this.userInfo.bindingPhone = this.qqPhone.mobile;
      this.userInfoOne.contactName = this.userInfo.sellerNick;
      this.userInfoOne.qq = this.qqPhone.qq;
      this.userInfoOne.mobile = this.qqPhone.mobile;
      this.userInfoOne.vcode = this.message.vcode;

      updateSellerSetting({
        tbPhoneBindingDTO: this.userInfo,
        sellerDTO: this.userInfoOne,
      })
        .then((res) => {
          console.log(res)
          if (res.code == '0') {
            this.$message.error(res.message);
          } else {
             this.$message.success("保存设置成功");
          }
         
        })
        .catch((err) => {});
    },
    //手机正则表达判断
    checkPhone() {
      var phone = document.getElementById("phone").value;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message("手机号码有误,请重填");
        return false;
      }
      if (this.userInfo.mobile.length < 11) {
        this.dis = true;
      }
    },
    verificationCode() {
      if (this.userInfo.mobile.length < 11) {
        this.dis = true;
      } else {
        this.dis = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.titileDefinition {
  min-width: 1046px;
  height: 57px;
  background-color: #fff;
  line-height: 57px;
  padding: 0 30px;
  font-size: 16px;
  color: #2e3458;
  font-weight: bold;
  margin: 20px;
  border: 1px solid rgba(230, 230, 230, 1);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
.fenHao {
  width: 6px;
  height: 8px;
  color: rgba(255, 58, 39, 1);
  opacity: 1;
  vertical-align: middle;
  margin-left: 12px;
}
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 26px 30px;
  border: 1px solid rgba(230, 230, 230, 1);
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  opacity: 1;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 20px;
  .checked-content-box {
    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
    }
    .tips-box {
      width: 818px;
      height: 42px;
      line-height: 42px;
      position: relative;
      font-size: 14px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 25px;
      .background-span {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.1;
        top: 0;
        left: 0;
      }
    }
    .checked-box {
      font-size: 14px;
      padding-left: 10px;
      margin-top: 5px;
      margin-left: 40px;
      .check {
        display: block;
        margin-bottom: 16px;
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 72px;
          margin: 0 4px;
        }
      }
    }
  }
  .input-content-box {
    margin-top: 30px;
    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: rgba(254, 77, 69, 1);
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
    }
    .tips-box {
      width: 818px;
      height: 42px;
      line-height: 42px;
      position: relative;
      font-size: 14px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 25px;
      .background-span {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.1;
        top: 0;
        left: 0;
      }
    }
    .b1 {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .b2 {
      width: 98px;
      height: 32px;
      color: #666666;
border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
  &:active {
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
  }
    }
    .input-box {
      font-size: 14px;
      margin-top: 10px;
      padding-left: 55px;
      .item {
        margin-bottom: 10px;
        .item-name {
          display: inline-block;
          vertical-align: middle;
          // color: #333333;
          width: 40px;
        }
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 300px;
        }
        .code-input {
          display: inline-block;
          vertical-align: middle;
          width: 156px;
          margin-right: 12px;
        }
        .code-button {
          display: inline-block;
          vertical-align: middle;
          width: 130px;
          height: 32px;
          line-height: 30px;
          text-align: center;
          border-radius: 6px;
          background-color: #fff;
          cursor: pointer;
          > span {
            display: inline-block;
            position: relative;
            top: -12px;
          }
        }
      }
      .save-button {
        width: 167px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        margin-left: 60px;
      }
      .save-button:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
